import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

const StatColumn = ({ children }: { children: React.ReactNode }) => (
  <Box
    alignItems="center"
    justifyContent="center"
    textAlign="center"
    height="full"
    width="s80"
    cursor="pointer"
  >
    {children}
  </Box>
)

export default StatColumn
